export default "__VITE_ASSET__C4GkP8SB__"